var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgRedo = function SvgRedo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 13 13",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.638 1.822H1.502v-.807h2.96v3.068h-.779V2.064C1.651 3.268.748 5.886 1.667 8.184c.752 1.884 2.514 3.022 4.367 3.022.601 0 1.212-.12 1.8-.373a4.78 4.78 0 0 0 2.556-2.648 5.026 5.026 0 0 0 0-3.746l.72-.309c1.16 2.905-.175 6.246-2.977 7.45a5.303 5.303 0 0 1-2.098.433c-2.159 0-4.212-1.326-5.088-3.52-.965-2.415-.204-5.132 1.691-6.671Z",
    fillRule: "evenodd"
  })));
};

export default SvgRedo;